import { render, staticRenderFns } from "./createArchive.vue?vue&type=template&id=459858a8&scoped=true&"
import script from "./createArchive.vue?vue&type=script&lang=js&"
export * from "./createArchive.vue?vue&type=script&lang=js&"
import style0 from "./createArchive.vue?vue&type=style&index=0&id=459858a8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "459858a8",
  null
  
)

export default component.exports